export const productSupplierCatalogItemDefaultValues = {
  quantity: 1,
};
